import { useState } from 'react';

/**
 * Hook personalizado para manejar formularios con validación
 * @param {Object} initialValues - Valores iniciales del formulario
 * @param {Function} validationFunction - Función de validación que retorna un objeto con errores
 * @returns {Object} - Objeto con formData, errors, handlers y métodos de utilidad
 */
export const useForm = (initialValues, validationFunction = null) => {
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar error cuando el usuario comience a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    if (validationFunction) {
      const newErrors = validationFunction(formData);
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
    return true;
  };

  const resetForm = () => {
    setFormData(initialValues);
    setErrors({});
  };

  const setFieldError = (fieldName, errorMessage) => {
    setErrors(prev => ({
      ...prev,
      [fieldName]: errorMessage
    }));
  };

  const setMultipleErrors = (errorObject) => {
    setErrors(errorObject);
  };

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    handleInputChange,
    validateForm,
    resetForm,
    setFieldError,
    setMultipleErrors
  };
};